import React from "react";

import Snackbar from "@mui/material/Snackbar";

import useDailyReadPlayerDimensions from "@app/analytics/hooks/domHelpers/useDailyReadPlayerDimensions";

const ReportFeedbackSnackbar = ({
  show,
  children,
}: {
  show: boolean;
  children: React.ReactNode;
}) => {
  const dailyReadPlayerDimensions = useDailyReadPlayerDimensions();

  // the snackbar has a default offset of 24 px, which is a little too big when stacked on top
  // of the player, so just do half of that
  const verticalOffset = dailyReadPlayerDimensions.height - 12;

  return (
    <Snackbar
      open={show}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      sx={{
        zIndex: 90 /* must be lower than MR loading overlay */,
        // show the feedback snackbar above the daily read player, if visible
        transition: "margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        marginBottom: `${verticalOffset}px`,
      }}
    >
      {/* Snackbar component tries to force style onto its direct descendant; span is a buffer against that */}
      <span>{children}</span>
    </Snackbar>
  );
};

export default ReportFeedbackSnackbar;
